import cx from "classnames";
import React, { MouseEvent } from "react";

import { StateCallbacks } from "../../../state";
import { State, TableCellBlock } from "../../../types";
import { extractHumanReadableText, extractTextBlock } from "../util";

type Props = Readonly<{
  cell: TableCellBlock;
  fontInformation: State["fontInformation"];
  isHeader: boolean;
  onSelectBlock: StateCallbacks["onSelectBlock"];
  referencesLink?: React.ReactElement;
  selectedCell: string | null;
}>;

export const Cell = ({
  cell,
  fontInformation,
  isHeader,
  onSelectBlock,
  referencesLink,
  selectedCell,
}: Props) => {
  const contents = (
    <>
      {extractTextBlock(cell.element, cell.highlights)}
      {referencesLink}
    </>
  );
  const domProps = {
    className: cx({ selected: selectedCell === cell.id }, cell.confidenceClass, "cellzone"),
    colSpan: cell.colSpan,
    id: `support-${cell.id}`,
    onClick: (e: MouseEvent<HTMLElement>) => {
      e.preventDefault();
      e.stopPropagation();
      if (!cell.id || !onSelectBlock) {
        return;
      }
      onSelectBlock(cell.id, extractHumanReadableText(cell.element), e.ctrlKey);
    },
    rowSpan: cell.rowSpan,
  };
  return React.createElement(isHeader ? "th" : "td", domProps, contents);
};
Cell.displayName = "Cell";
